export type MediaType = "movie" | "tv";

export interface Title {
  id: string;
  type: MediaType;
  title: string;
  englishTitle: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  heat: number;
  director: string;
  cast: string[];
  duration: string;
  episodes?: string;
  tagline: string;
  synopsis: string;
  cover: string;
  backdrop: string;
  featured: boolean;
  badge?: string;
}

export const titles: Title[] = [
  {
    id: "chang-ye-zhi-guang",
    type: "movie",
    title: "长夜之光",
    englishTitle: "Light of the Long Night",
    year: 2025,
    region: "中国内地",
    genres: ["剧情", "悬疑"],
    rating: 8.7,
    heat: 9820,
    director: "沈墨川",
    cast: ["陆知远", "林砚秋", "周慕之", "许南乔"],
    duration: "128 分钟",
    tagline: "在最长的那一夜，有人替城市守住了灯。",
    synopsis:
      "一场突如其来的全城停电，让滨海小城的跨年夜陷入无边的沉默。值班调度员顾行舟发现，停电并非事故，而是一场被精心藏了十七年的旧案的尾声。他必须在黎明前找到那盏唯一还亮着的灯，也要在时间耗尽之前，与父亲的过往和解。影片以冷静的长镜头与克制的配乐，讲述一个普通人在黑夜里选择成为光的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20artwork%20of%20a%20lone%20figure%20standing%20on%20a%20rain%20soaked%20city%20street%20at%20night%20with%20warm%20single%20streetlamp%20glow%20deep%20navy%20tones%20melancholic%20atmospheric%20minimal%20composition%20no%20text&width=600&height=840&seq=cyg-cover-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dark%20coastal%20city%20at%20night%20during%20a%20blackout%20with%20one%20glowing%20window%20and%20orange%20sodium%20streetlights%20deep%20navy%20and%20amber%20tones%20atmospheric%20film%20still%20no%20text&width=1920&height=1080&seq=cyg-back-01&orientation=landscape",
    featured: true,
    badge: "年度口碑",
  },
  {
    id: "shan-hai-shi-zhe",
    type: "movie",
    title: "山海拾者",
    englishTitle: "The Collector of Mountains and Seas",
    year: 2024,
    region: "中国内地",
    genres: ["奇幻", "冒险"],
    rating: 8.2,
    heat: 9130,
    director: "宋归野",
    cast: ["江照白", "苏晚棠", "谢无咎"],
    duration: "142 分钟",
    tagline: "地图的尽头，是另一个故事的开头。",
    synopsis:
      "古籍修复师洛青禾在修补一册残卷时，发现夹层中藏着一张会自行改写的海图。她循着图上的墨迹，从云贵高原的溶洞走到东海尽头的小岛，一路上遇见了守护遗迹的守山人、走私文物的中间人，以及一个只想把太奶奶的故事讲完的少年。影片把奇幻想象落在真实的山水里，拍出了一段温柔而辽阔的公路式冒险。",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%20of%20a%20traveler%20holding%20an%20ancient%20map%20before%20misty%20karst%20mountains%20and%20a%20glowing%20sea%20deep%20navy%20teal%20with%20warm%20gold%20accents%20painterly%20atmospheric%20no%20text&width=600&height=840&seq=shsz-cover-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20cinematic%20landscape%20of%20misty%20chinese%20karst%20mountains%20with%20an%20ancient%20stone%20path%20and%20a%20distant%20lone%20traveler%20silhouette%20deep%20blue%20and%20golden%20light%20film%20still%20no%20text&width=1920&height=1080&seq=shsz-back-02&orientation=landscape",
    featured: true,
    badge: "口碑黑马",
  },
  {
    id: "nan-fang-de-qi-tian",
    type: "movie",
    title: "南方的第七天",
    englishTitle: "Seven Days in the South",
    year: 2024,
    region: "中国香港",
    genres: ["爱情", "剧情"],
    rating: 7.9,
    heat: 8240,
    director: "何靖行",
    cast: ["梁雨桐", "吴庚言", "陈蔓"],
    duration: "112 分钟",
    tagline: "雨季只有七天，他们说好不互相等。",
    synopsis:
      "台风季的第七天，在一家快要关门的老式冰室，代课老师阿翎和胶片冲洗师阿介约定：这七天里，彼此不用交代过去。他们一起走过湿透的骑楼，修补一卷被遗忘的底片，也在最后一场雨里学会了怎么好好告别。影片用潮湿的南方空气包裹一段轻盈的感情，不煽情，却让人久久不散。",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20film%20poster%20of%20two%20people%20under%20a%20shared%20umbrella%20outside%20a%20vintage%20hong%20kong%20cafe%20in%20heavy%20rain%20deep%20blue%20teal%20tones%20with%20warm%20yellow%20lantern%20glow%20nostalgic%20no%20text&width=600&height=840&seq=nfdqt-cover-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20street%20scene%20of%20hong%20kong%20arcade%20shops%20at%20dusk%20in%20heavy%20rain%20with%20warm%20neon%20yellow%20signs%20reflecting%20on%20wet%20pavement%20deep%20teal%20and%20amber%20film%20still%20no%20text&width=1920&height=1080&seq=nfdqt-back-03&orientation=landscape",
    featured: true,
    badge: "新片上线",
  },
  {
    id: "di-qi-hao-tong-dao",
    type: "movie",
    title: "第七号通道",
    englishTitle: "Corridor No.7",
    year: 2025,
    region: "韩国",
    genres: ["动作", "犯罪"],
    rating: 8.0,
    heat: 8890,
    director: "尹在焕",
    cast: ["朴道河", "申雪琳", "崔民载"],
    duration: "121 分钟",
    tagline: "出口就在前面，但门后不是自由。",
    synopsis:
      "前谈判专家在押送证人途中遭遇精心策划的劫车，被困在一座废弃地铁站的第七号通道。对方不要钱，只要一份从未公开的乘客名单。在密闭的地下空间里，一场关于时间、信任和筹码的博弈持续了整整十三个小时。影片几乎全部在地下实景拍摄，节奏凌厉，几乎没有喘息的空间。",
    cover:
      "https://readdy.ai/api/search-image?query=action%20thriller%20movie%20poster%20of%20a%20man%20walking%20down%20an%20abandoned%20subway%20tunnel%20with%20flickering%20lights%20deep%20navy%20and%20orange%20emergency%20glow%20gritty%20high%20contrast%20no%20text&width=600&height=840&seq=dqhzt-cover-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=gritty%20action%20film%20still%20of%20an%20abandoned%20industrial%20subway%20tunnel%20with%20orange%20emergency%20lights%20and%20dramatic%20long%20shadows%20deep%20blue%20atmosphere%20no%20text&width=1920&height=1080&seq=dqhzt-back-04&orientation=landscape",
    featured: true,
  },
  {
    id: "xing-ji-shou-ye-ren",
    type: "movie",
    title: "星际守夜人",
    englishTitle: "The Star Nightwatch",
    year: 2023,
    region: "美国",
    genres: ["科幻", "剧情"],
    rating: 8.4,
    heat: 9460,
    director: "艾略特·凡恩",
    cast: ["马修·凯尔", "诺拉·贝克", "伊桑·里德"],
    duration: "136 分钟",
    tagline: "宇宙最安静的地方，有人在替你值守。",
    synopsis:
      "在一座被废弃的深空观测站里，最后一名值守员每天向地球发送一条无人接收的问候。当信号突然收到回复时，他必须决定：相信那个声音，还是相信自己在七年孤独中形成的判断。影片以极少的对白与巨大的星空画面，讨论人类对陪伴最深的渴望。",
    cover:
      "https://readdy.ai/api/search-image?query=sci%20fi%20movie%20poster%20of%20an%20astronaut%20silhouette%20against%20a%20vast%20deep%20navy%20starry%20nebula%20with%20a%20single%20warm%20amber%20distant%20sun%20minimal%20epic%20composition%20no%20text&width=600&height=840&seq=xjsyr-cover-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=vast%20cinematic%20space%20view%20of%20deep%20navy%20nebula%20with%20scattered%20stars%20and%20a%20tiny%20space%20station%20silhouette%20warm%20amber%20light%20at%20horizon%20film%20still%20no%20text&width=1920&height=1080&seq=xjsyr-back-05&orientation=landscape",
    featured: true,
    badge: "高分经典",
  },
  {
    id: "lao-jie-de-mian-bao",
    type: "movie",
    title: "老街的面包房",
    englishTitle: "The Bakery on Old Street",
    year: 2023,
    region: "日本",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    heat: 7620,
    director: "小野寺真夏",
    cast: ["森川绫", "高桥亨", "中村澪"],
    duration: "108 分钟",
    tagline: "面团发酵的时间里，人会慢慢回来。",
    synopsis:
      "母亲去世后，离家十二年的女儿回到老街，接手那间只剩一台老式烤箱的面包房。她不会做面包，只知道每天清晨五点必须点炉。邻居、邮差、放学路过的孩子一个个走进来，也一点点把她重新缝回这座小镇的生活里。这是一部关于食物与修复的温柔小品。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20heartfelt%20film%20poster%20of%20a%20small%20japanese%20bakery%20window%20at%20dawn%20with%20fresh%20bread%20and%20a%20woman%20inside%20deep%20teal%20night%20outside%20and%20amber%20light%20inside%20cozy%20minimal%20no%20text&width=600&height=840&seq=ljmb-cover-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cozy%20small%20bakery%20interior%20at%20early%20morning%20with%20warm%20amber%20light%20wooden%20shelves%20and%20a%20baking%20oven%20glow%20soft%20shadows%20cinematic%20film%20still%20no%20text&width=1920&height=1080&seq=ljmb-back-06&orientation=landscape",
    featured: false,
    badge: "治愈系",
  },
  {
    id: "shen-hai-hui-yin",
    type: "movie",
    title: "深海回音",
    englishTitle: "Echoes from the Deep",
    year: 2022,
    region: "英国",
    genres: ["悬疑", "科幻"],
    rating: 7.7,
    heat: 6980,
    director: "艾米莉亚·柯尔",
    cast: ["汤姆·哈特利", "莉亚·莫里斯"],
    duration: "118 分钟",
    tagline: "海底的声音，比沉默更让人害怕。",
    synopsis:
      "一支深海勘测队在马里亚纳海沟边缘录到一段规律声波，频率与三十年前失联潜艇的求救信号完全一致。随着下潜深度增加，队员开始听见各自最不愿回想的往事。真相究竟藏在海沟底部，还是在每个人心里？",
    cover:
      "https://readdy.ai/api/search-image?query=suspense%20film%20poster%20of%20a%20deep%20ocean%20dive%20with%20a%20tiny%20submersible%20glowing%20in%20dark%20navy%20water%20mysterious%20atmospheric%20minimal%20composition%20no%20text&width=600&height=840&seq=shhy-cover-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20underwater%20cinematic%20view%20with%20a%20small%20submersible%20headlight%20cutting%20through%20dark%20navy%20water%20and%20marine%20snow%20atmospheric%20no%20text&width=1920&height=1080&seq=shhy-back-07&orientation=landscape",
    featured: false,
  },
  {
    id: "wu-hou-san-dian",
    type: "movie",
    title: "午后三点",
    englishTitle: "Three in the Afternoon",
    year: 2022,
    region: "法国",
    genres: ["爱情", "文艺"],
    rating: 7.5,
    heat: 5820,
    director: "克洛伊·杜兰",
    cast: ["艾丽莎·贝尔", "让·佩兰"],
    duration: "96 分钟",
    tagline: "每天三点的长椅，是谁先来的？",
    synopsis:
      "里昂的一座公园长椅上，两个人连续二十七个午后坐在同一端，却从没有说过话。直到第十八个下午，一张被风吹落的乐谱打破沉默。影片用安静的镜头记录一段几乎无声的靠近，像午后阳光落在书页上的移动。",
    cover:
      "https://readdy.ai/api/search-image?query=arthouse%20romance%20film%20poster%20of%20an%20empty%20park%20bench%20in%20afternoon%20sunlight%20with%20two%20distant%20figures%20deep%20green%20and%20warm%20yellow%20soft%20film%20grain%20no%20text&width=600&height=840&seq=whsd-cover-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=sunlit%20french%20park%20path%20in%20late%20afternoon%20with%20long%20tree%20shadows%20and%20warm%20golden%20haze%20cinematic%20wide%20shot%20no%20text&width=1920&height=1080&seq=whsd-back-08&orientation=landscape",
    featured: false,
  },
  {
    id: "zui-hou-yi-tang-ke",
    type: "movie",
    title: "最后一堂课",
    englishTitle: "The Last Lesson",
    year: 2025,
    region: "中国内地",
    genres: ["剧情", "青春"],
    rating: 8.3,
    heat: 8710,
    director: "温知白",
    cast: ["何砚", "顾清禾", "于承安"],
    duration: "124 分钟",
    tagline: "黑板擦干净之前，再说一句话。",
    synopsis:
      "一所即将撤并的县城中学，只剩下高三年级和三位老师。语文老师老陈决定在最后一百天里，带学生做完一件从没做过的事：把他们的村子写成一本书。当撤并通知最终下达，所有人都在那本薄薄的册子里，找到了留下的证据。",
    cover:
      "https://readdy.ai/api/search-image?query=inspirational%20drama%20poster%20of%20a%20rural%20chinese%20classroom%20with%20blackboard%20chalk%20and%20sunlight%20through%20old%20windows%20deep%20blue%20desks%20warm%20amber%20light%20nostalgic%20no%20text&width=600&height=840&seq=zhytk-cover-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=empty%20rural%20school%20classroom%20with%20wooden%20desks%20and%20chalk%20blackboard%20warm%20afternoon%20light%20streaming%20through%20window%20cinematic%20film%20still%20no%20text&width=1920&height=1080&seq=zhytk-back-09&orientation=landscape",
    featured: false,
    badge: "热映",
  },
  {
    id: "sha-mo-li-de-xin",
    type: "movie",
    title: "沙漠里的信",
    englishTitle: "Letters in the Desert",
    year: 2021,
    region: "美国",
    genres: ["西部", "剧情"],
    rating: 7.9,
    heat: 5340,
    director: "山姆·韦勒",
    cast: ["詹姆斯·洛克", "卡门·伊达尔戈"],
    duration: "131 分钟",
    tagline: "邮差不送希望，他只是不停下。",
    synopsis:
      "一九三零年代，一名老邮差骑着一匹瘦马穿越荒漠，把信送到最后几个还没通路的牧场。他的包里有一封信，收件人早已不在人世。为了这封信，他绕了四百公里的路。风沙与夕阳构成了这部公路西部片的全部浪漫。",
    cover:
      "https://readdy.ai/api/search-image?query=western%20drama%20poster%20of%20a%20lone%20rider%20on%20horseback%20crossing%20a%20vast%20desert%20under%20deep%20blue%20dusk%20sky%20warm%20orange%20sand%20epic%20minimal%20no%20text&width=600&height=840&seq=smldx-cover-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20western%20desert%20landscape%20at%20blue%20hour%20with%20rolling%20orange%20sand%20dunes%20and%20a%20distant%20rider%20silhouette%20cinematic%20wide%20shot%20no%20text&width=1920&height=1080&seq=smldx-back-10&orientation=landscape",
    featured: false,
  },
  {
    id: "feng-qi-lu-deng",
    type: "movie",
    title: "风起路灯",
    englishTitle: "When the Wind Rises",
    year: 2024,
    region: "中国台湾",
    genres: ["爱情", "青春"],
    rating: 7.6,
    heat: 6450,
    director: "林晏如",
    cast: ["许柏宇", "程小满"],
    duration: "103 分钟",
    tagline: "那年夏天的风，一直没停过。",
    synopsis:
      "台东的一所高中，两个都喜欢在天台上吃午饭的学生，因为一盏坏掉的路灯开始说话。整整一个夏天，他们一边等灯修好，一边把不敢说的心事写进笔记本。灯终于亮起的那天，风把其中一页吹走了。",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20coming%20of%20age%20film%20poster%20of%20two%20teenagers%20on%20a%20rooftop%20under%20a%20single%20street%20lamp%20at%20dusk%20deep%20blue%20sky%20warm%20yellow%20glow%20soft%20film%20grain%20no%20text&width=600&height=840&seq=fqld-cover-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=quiet%20taiwanese%20coastal%20town%20street%20at%20dusk%20with%20single%20street%20lamp%20glowing%20and%20sea%20breeze%20deep%20blue%20and%20warm%20amber%20cinematic%20film%20still%20no%20text&width=1920&height=1080&seq=fqld-back-11&orientation=landscape",
    featured: false,
  },
  {
    id: "huo-che-zhan-zhi-nan",
    type: "movie",
    title: "火车站之南",
    englishTitle: "South of the Station",
    year: 2021,
    region: "印度",
    genres: ["剧情", "家庭"],
    rating: 8.1,
    heat: 5890,
    director: "拉维·钱德拉",
    cast: ["阿迪提亚·饶", "米拉·库马尔", "萨姆·德赛"],
    duration: "147 分钟",
    tagline: "站台很长，回家的那段最短。",
    synopsis:
      "在孟买火车站南侧的一条巷子里，一家小小的茶摊支撑起三个家庭的生活。茶摊老板的女儿考上了远方的大学，这让整条巷子都开始重新思考“留下”与“离开”。影片用大量熙攘的站台镜头，把一座城市的呼吸拍得滚烫。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20indian%20drama%20film%20poster%20of%20a%20busy%20train%20station%20platform%20at%20night%20with%20warm%20saffron%20lights%20and%20deep%20navy%20shadows%20documentary%20style%20no%20text&width=600&height=840&seq=hczzn-cover-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=busy%20indian%20railway%20station%20at%20night%20with%20steam%20and%20warm%20orange%20platform%20lights%20deep%20blue%20sky%20cinematic%20wide%20shot%20no%20text&width=1920&height=1080&seq=hczzn-back-12&orientation=landscape",
    featured: false,
  },
  {
    id: "yi-ye-hai-tu",
    type: "tv",
    title: "奕夜海图",
    englishTitle: "Night Charts",
    year: 2025,
    region: "中国内地",
    genres: ["悬疑", "罪案"],
    rating: 8.9,
    heat: 9950,
    director: "闵寒川",
    cast: ["傅时晏", "甘露", "邵亭山", "黎安"],
    duration: "45 分钟",
    episodes: "全 32 集",
    tagline: "每张海图背后，都有人想让它消失。",
    synopsis:
      "一份旧海图牵出连环命案，滨海城市接连发生三起船难，死者都持有同一份旧海图的副本。档案修复师沈书言被卷入调查，逐渐发现父亲的失踪与一张从未公开的航线有关。全剧以双线叙事推进，在档案室的纸尘与夜海的雾之间切换，编织出一张绵密的人性之网。",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20mystery%20tv%20series%20poster%20of%20an%20old%20nautical%20chart%20on%20a%20desk%20with%20magnifier%20and%20foggy%20harbor%20lights%20deep%20navy%20and%20amber%20atmospheric%20no%20text&width=600&height=840&seq=yyht-cover-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=foggy%20harbor%20at%20night%20with%20old%20cargo%20ships%20and%20warm%20yellow%20dock%20lights%20deep%20navy%20blue%20water%20cinematic%20mystery%20film%20still%20no%20text&width=1920&height=1080&seq=yyht-back-13&orientation=landscape",
    featured: true,
    badge: "本周热度第一",
  },
  {
    id: "chun-shan-ji",
    type: "tv",
    title: "春山记",
    englishTitle: "Chronicle of Spring Mountain",
    year: 2024,
    region: "中国内地",
    genres: ["古装", "剧情"],
    rating: 8.5,
    heat: 9320,
    director: "陆云舸",
    cast: ["谢清源", "顾兰舟", "沈玉筝", "闻川"],
    duration: "48 分钟",
    episodes: "全 40 集",
    tagline: "山还在，人已换了春秋。",
    synopsis:
      "一纸调令，让年轻的县令走进深山腹地的小县。他要修一条通往县外的路，却发现每一次动土都牵动着一个家族的旧账。全剧以四季为章节，用山水与农事托住一段关于基层治理与人心取舍的叙事，被观众称为“能闻到泥土味的古装剧”。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20chinese%20period%20drama%20poster%20of%20a%20scholar%20official%20standing%20before%20layered%20spring%20mountains%20in%20mist%20deep%20navy%20ink%20wash%20with%20warm%20gold%20accents%20no%20text&width=600&height=840&seq=csj-cover-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=ink%20wash%20style%20ancient%20chinese%20mountain%20village%20in%20spring%20mist%20with%20terraced%20fields%20deep%20blue%20and%20soft%20gold%20light%20cinematic%20no%20text&width=1920&height=1080&seq=csj-back-14&orientation=landscape",
    featured: true,
    badge: "古装精品",
  },
  {
    id: "di-du-yi-ju",
    type: "tv",
    title: "第 3 区的清晨",
    englishTitle: "Morning in District 3",
    year: 2025,
    region: "韩国",
    genres: ["都市", "职场"],
    rating: 8.1,
    heat: 8760,
    director: "金兑旭",
    cast: ["徐智安", "李道贤", "韩世凛"],
    duration: "62 分钟",
    episodes: "全 16 集",
    tagline: "城市醒得比人早。",
    synopsis:
      "第三区的一家二十四小时便利店，是整条街的深夜避难所。夜班店员、外卖骑手、失眠的法官、刚辞职的编剧，在同一盏灯下交替出现。全剧几乎不设主线，只用十六个清晨串起一群普通人的交叉路口，被评论称作“最能听见城市呼吸的韩剧”。",
    cover:
      "https://readdy.ai/api/search-image?query=urban%20korean%20drama%20poster%20of%20a%20convenience%20store%20glowing%20on%20an%20empty%20city%20street%20before%20dawn%20deep%20blue%20tones%20warm%20yellow%20interior%20light%20cinematic%20no%20text&width=600&height=840&seq=d3qd-cover-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=empty%20modern%20seoul%20street%20before%20dawn%20with%20a%20glowing%20convenience%20store%20and%20cold%20blue%20light%20contrast%20warm%20yellow%20interior%20cinematic%20film%20still%20no%20text&width=1920&height=1080&seq=d3qd-back-15&orientation=landscape",
    featured: true,
  },
  {
    id: "wu-ren-jie-shou",
    type: "tv",
    title: "无人接收",
    englishTitle: "No One Receives",
    year: 2023,
    region: "英国",
    genres: ["科幻", "悬疑"],
    rating: 8.6,
    heat: 8450,
    director: "奥利弗·格兰特",
    cast: ["艾拉·沃森", "丹尼尔·福斯特"],
    duration: "52 分钟",
    episodes: "全 8 集",
    tagline: "所有消息都发出去了，只是没人收到。",
    synopsis:
      "一夜之间，全世界所有通讯设备都能发送，却无法接收。一位语言学家发现，收到的信息并未消失，而是被某种规则排队延后。为了找到那封写给女儿却迟迟不到的信，她开始逆向解码整座城市的沉默。",
    cover:
      "https://readdy.ai/api/search-image?query=sci%20fi%20mystery%20series%20poster%20of%20a%20vintage%20radio%20tower%20silhouette%20under%20a%20deep%20navy%20night%20sky%20with%20a%20single%20amber%20beacon%20glow%20minimal%20atmospheric%20no%20text&width=600&height=840&seq=wrjs-cover-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=lonely%20radio%20antenna%20on%20a%20hill%20at%20night%20against%20deep%20navy%20sky%20with%20scattered%20stars%20and%20warm%20red%20beacon%20cinematic%20no%20text&width=1920&height=1080&seq=wrjs-back-16&orientation=landscape",
    featured: false,
    badge: "高分悬疑",
  },
  {
    id: "chang-an-de-chu-fang",
    type: "tv",
    title: "长巷的厨房",
    englishTitle: "Kitchen in the Long Alley",
    year: 2024,
    region: "中国内地",
    genres: ["都市", "生活"],
    rating: 8.0,
    heat: 7980,
    director: "贺家树",
    cast: ["潘雅", "赵衡", "崔一鸣", "林苗"],
    duration: "42 分钟",
    episodes: "全 30 集",
    tagline: "烟火气，是最实在的团圆。",
    synopsis:
      "一条即将改造的老巷里，四户人家共用一口灶。有人想搬走，有人舍不得，有人只是想再多做一顿饭。剧集以一菜一集的方式铺陈，把市井生活里的琐碎与体面拍得有滋有味，被观众称为“深夜勿看”。",
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20chinese%20slice%20of%20life%20drama%20poster%20of%20a%20steaming%20wok%20in%20a%20narrow%20old%20alley%20kitchen%20at%20dusk%20deep%20teal%20shadows%20warm%20amber%20light%20no%20text&width=600&height=840&seq=cacf-cover-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=busy%20shared%20kitchen%20in%20a%20chinese%20old%20alley%20at%20dinner%20time%20with%20steam%20and%20warm%20amber%20lamps%20against%20deep%20blue%20evening%20no%20text&width=1920&height=1080&seq=cacf-back-17&orientation=landscape",
    featured: false,
  },
  {
    id: "bei-fang-de-hai",
    type: "tv",
    title: "北方的海",
    englishTitle: "The Northern Sea",
    year: 2023,
    region: "中国内地",
    genres: ["年代", "家庭"],
    rating: 8.4,
    heat: 7210,
    director: "于牧川",
    cast: ["齐守成", "白玉兰", "孙向阳"],
    duration: "46 分钟",
    episodes: "全 36 集",
    tagline: "潮水退了，礁石才会露出形状。",
    synopsis:
      "从上世纪八十年代到当下，一座北方渔港的三代人，用一条船、一间冷库和一场从未打完的官司，写下自己的编年史。剧集以潮汐为节奏，避开宏大叙事，把时代的变化藏在每一顿饭、每一次出海的细节里。",
    cover:
      "https://readdy.ai/api/search-image?query=period%20drama%20poster%20of%20a%20northern%20chinese%20fishing%20harbor%20with%20wooden%20boats%20and%20grey%20blue%20sea%20deep%20navy%20sky%20warm%20amber%20dusk%20light%20nostalgic%20no%20text&width=600&height=840&seq=bfdh-cover-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=grey%20blue%20northern%20fishing%20harbor%20at%20dusk%20with%20wooden%20boats%20and%20distant%20lighthouse%20warm%20amber%20light%20cinematic%20period%20film%20still%20no%20text&width=1920&height=1080&seq=bfdh-back-18&orientation=landscape",
    featured: false,
  },
  {
    id: "shuang-shi-dai",
    type: "tv",
    title: "双时代",
    englishTitle: "Two Eras",
    year: 2025,
    region: "日本",
    genres: ["科幻", "悬疑"],
    rating: 8.2,
    heat: 8850,
    director: "藤井悠斗",
    cast: ["绫濑真琴", "石田凉", "佐野文"],
    duration: "50 分钟",
    episodes: "全 10 集",
    tagline: "同一个人，在两个时代里都想活下去。",
    synopsis:
      "一架意外启动的实验装置，让一名建筑设计师的意识在两个时代之间来回跳转。一个是正在重建的战后街区，一个是被数字模型完全复刻的当下。她渐渐发现，两个时代里都有人期待她不要再回来。",
    cover:
      "https://readdy.ai/api/search-image?query=sci%20fi%20japanese%20drama%20poster%20of%20a%20split%20city%20street%20one%20side%20old%20one%20side%20modern%20deep%20navy%20and%20warm%20amber%20glow%20clean%20minimal%20composition%20no%20text&width=600&height=840&seq=ssd-cover-19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=split%20timeline%20cinematic%20city%20street%20half%20mid%20century%20and%20half%20modern%20digital%20deep%20blue%20night%20warm%20amber%20windows%20no%20text&width=1920&height=1080&seq=ssd-back-19&orientation=landscape",
    featured: true,
  },
  {
    id: "xiang-cun-zhi-shi",
    type: "tv",
    title: "乡村医事",
    englishTitle: "Country Doctor",
    year: 2022,
    region: "中国内地",
    genres: ["剧情", "纪实"],
    rating: 8.7,
    heat: 6890,
    director: "孟迟",
    cast: ["罗守义", "姜春燕", "白卫东"],
    duration: "44 分钟",
    episodes: "全 24 集",
    tagline: "一盏灯，一个药箱，一条山路。",
    synopsis:
      "老村医三十年间背着药箱走遍了附近七座山头的每一条小路。剧集没有激烈的冲突，只有一个个清晨出诊、深夜归家的日常，用极朴素的镜头记录下乡村医疗的真实模样与其中的人情温度。",
    cover:
      "https://readdy.ai/api/search-image?query=rural%20chinese%20drama%20poster%20of%20an%20old%20doctor%20with%20a%20medicine%20box%20walking%20a%20mountain%20path%20at%20dawn%20deep%20blue%20mist%20warm%20amber%20sunrise%20documentary%20feel%20no%20text&width=600&height=840&seq=xczs-cover-20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=misty%20chinese%20mountain%20village%20path%20at%20sunrise%20with%20a%20lone%20figure%20walking%20deep%20blue%20morning%20tones%20warm%20amber%20light%20documentary%20cinematic%20no%20text&width=1920&height=1080&seq=xczs-back-20&orientation=landscape",
    featured: false,
  },
  {
    id: "tai-yang-xi",
    type: "tv",
    title: "太阳系失踪案",
    englishTitle: "The Missing Solar System",
    year: 2024,
    region: "美国",
    genres: ["科幻", "喜剧"],
    rating: 7.8,
    heat: 8120,
    director: "布兰登·诺瓦克",
    cast: ["山姆·贝克", "格蕾丝·吴", "阿德里安·皮尔斯"],
    duration: "40 分钟",
    episodes: "全 12 集",
    tagline: "地球还在，只是太阳系不见了。",
    synopsis:
      "一个经费不足的太空监测小组突然发现，太阳系外围的三颗行星从所有星图中消失了。他们没有飞船，没有预算，只有一间办公室和一台老旧的追踪仪。于是几个普通人开始用自己的方式，把宇宙找回来。这是一部荒诞又温暖的太空喜剧。",
    cover:
      "https://readdy.ai/api/search-image?query=quirky%20sci%20fi%20comedy%20series%20poster%20of%20a%20retro%20radio%20telescope%20pointed%20at%20a%20star%20filled%20deep%20navy%20sky%20with%20one%20empty%20glowing%20gap%20warm%20amber%20accent%20no%20text&width=600&height=840&seq=tyxx-cover-21&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=retro%20observatory%20dome%20on%20a%20mountain%20at%20night%20under%20deep%20navy%20starry%20sky%20with%20warm%20amber%20interior%20glow%20cinematic%20no%20text&width=1920&height=1080&seq=tyxx-back-21&orientation=landscape",
    featured: false,
  },
  {
    id: "wan-an-ba-bai-dian",
    type: "tv",
    title: "晚安，八点",
    englishTitle: "Goodnight at Eight",
    year: 2022,
    region: "泰国",
    genres: ["爱情", "生活"],
    rating: 7.4,
    heat: 6240,
    director: "皮拉·瓦塔纳",
    cast: ["纳塔蓬·坤", "素妲·查瓦"],
    duration: "38 分钟",
    episodes: "全 20 集",
    tagline: "每天八点，电视里有人替你说晚安。",
    synopsis:
      "一档连续播了十五年的晚间生活节目即将停播，主持人却收到了大量观众的来信。她决定在最后一百期里，把每一个普通人的故事都读出来。而每晚八点守着电视的那个年轻人，终于在最后一期走到了演播室门口。",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20romance%20thai%20drama%20poster%20of%20a%20tv%20studio%20glowing%20with%20warm%20amber%20light%20against%20deep%20navy%20night%20and%20rain%20on%20window%20soft%20cinematic%20no%20text&width=600&height=840&seq=wabbd-cover-22&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=empty%20tv%20studio%20set%20with%20warm%20amber%20lights%20and%20a%20single%20chair%20against%20deep%20navy%20darkness%20cinematic%20quiet%20film%20still%20no%20text&width=1920&height=1080&seq=wabbd-back-22&orientation=landscape",
    featured: false,
  },
  {
    id: "di-tie-shang-de-shi-ren",
    type: "tv",
    title: "地铁上的诗人",
    englishTitle: "The Poet on the Metro",
    year: 2023,
    region: "法国",
    genres: ["剧情", "文艺"],
    rating: 8.3,
    heat: 5670,
    director: "雨果·勒梅尔",
    cast: ["克莱尔·杜布瓦", "马修·桑德"],
    duration: "34 分钟",
    episodes: "全 6 集",
    tagline: "每个赶路的人，都带着一首没写完的诗。",
    synopsis:
      "一位退休的地铁司机开始在清晨的车厢里给陌生人读诗。六集六个乘客，每个人都在一次短短的通勤里，被一句话击中。剧集以极简的镜头语言，把巴黎的日常交通写成一间移动的、不设门票的剧场。",
    cover:
      "https://readdy.ai/api/search-image?query=arty%20french%20drama%20poster%20of%20an%20empty%20metro%20carriage%20at%20dawn%20with%20warm%20amber%20ceiling%20lights%20and%20deep%20navy%20windows%20poetic%20minimal%20no%20text&width=600&height=840&seq=dtsdsr-cover-23&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=empty%20paris%20metro%20carriage%20interior%20at%20early%20morning%20warm%20amber%20lights%20deep%20blue%20tunnel%20outside%20cinematic%20no%20text&width=1920&height=1080&seq=dtsdsr-back-23&orientation=landscape",
    featured: false,
  },
  {
    id: "huang-hun-de-deng-ta",
    type: "tv",
    title: "黄昏的灯塔",
    englishTitle: "Lighthouse at Dusk",
    year: 2021,
    region: "中国内地",
    genres: ["年代", "悬疑"],
    rating: 8.0,
    heat: 5410,
    director: "费远山",
    cast: ["邓青海", "苏雪舸", "汪立冬"],
    duration: "47 分钟",
    episodes: "全 28 集",
    tagline: "灯一直亮着，人却再没回来。",
    synopsis:
      "九十年代的海岛灯塔站，一名守塔人失踪，只留下一本写满数字的值班日志。二十年后，他的女儿以记者身份回到岛上，试图找出那串数字的含义。潮水每退一次，就露出一段更早被埋起来的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=period%20mystery%20drama%20poster%20of%20an%20old%20lighthouse%20on%20a%20rocky%20island%20at%20dusk%20with%20warm%20amber%20beacon%20beam%20over%20deep%20navy%20sea%20no%20text&width=600&height=840&seq=hhddt-cover-24&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=old%20lighthouse%20on%20rocky%20shore%20at%20dusk%20with%20warm%20amber%20beam%20sweeping%20over%20deep%20navy%20waves%20cinematic%20moody%20no%20text&width=1920&height=1080&seq=hhddt-back-24&orientation=landscape",
    featured: false,
  },
];

export const featuredTitles = titles.filter((item) => item.featured);

export const trendingTitles = [...titles].sort((a, b) => b.heat - a.heat);